// import request from '../../utils/request'

import request from '../../utils/request'

const menu = {
  state: {
    onlineFuncs: [],
    childrenMenus: [],
    reportsMenus: []
  },
  mutations: {
    set_children_menus (state, data) {
      console.log(data, '----c-')
      state.childrenMenus = data
    },
    set_reports_menus (state, data) {
      state.reportsMenus = data
    },
    set_online_funcs (state, data) {
      let onlinefuncs = state.onlineFuncs
      let index = onlinefuncs.findIndex(item => Number(item.name) === Number(data.name))
      if (index === -1) {
        state.onlineFuncs.push(data)
      }
    }
  },
  actions: {
    // 菜单
    getMenuList ({commit}, opts) {
      return new Promise((resolve, reject) => {
        request({
          url: '/kfgl/menu/getMenuList',
          method: 'get',
          data: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    // 用户菜单
    getUserMenu ({commit}, opts) {
      return new Promise((resolve, reject) => {
        request({
          url: '/kfgl/menu/getUserMenu',
          method: 'get',
          params: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    addMenu ({commit}, opts) {
      return new Promise((resolve, reject) => {
        request({
          url: '/kfgl/menu/addMenu',
          method: 'post',
          data: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    updateMenu ({commit}, opts) {
      return new Promise((resolve, reject) => {
        request({
          url: '/kfgl/menu/updateMenu',
          method: 'post',
          data: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    menuOrder ({commit}, opts) {
      return request({
        url: '/kfgl/menu/menuOrder',
        method: 'post',
        data: opts
      })
    },
    delMenu ({commit}, opts) {
      return request({
        url: '/kfgl/menu/delmenu',
        method: 'post',
        data: opts
      })
    },
    getMenuBtnList ({commit}) {
      return new Promise((resolve, reject) => {
        request({
          url: '/kfgl/menu/getMenuBtnList',
          method: 'get'
        }).then(res => {
          resolve(res)
        })
      })
    },
    // 获取按钮
    getBtnByMenu ({commit}, opts) {
      return new Promise((resolve, reject) => {
        return request({
          url: '/kfgl/menu/getBtnByMenu',
          method: 'get',
          params: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    getMenuReports ({commit}, opts) {
      return new Promise((resolve, reject) => {
        return request({
          url: '/kfgl/menu/getReports',
          method: 'get',
          params: opts
        }).then(res => {
          resolve(res)
        })
      })
    },
    updateMenuReports ({commit}, opts) {
      return request({
        url: '/kfgl/menu/updateMenuReports',
        method: 'post',
        data: opts
      })
    },

  }
}

export default menu
